import React, { ReactElement } from "react";
import { ThemeProvider } from "styled-components";

import Icon from "components/Icon";
import OpenPositionList from "components/OpenPositionList";
import Section from "components/Section";
import { useHeader } from "hooks";
import useIsInEditMode from "hooks/useIsInEditMode";
import { addEditAttributes } from "utils/episerver";

import {
    Container,
    Content,
    Heading,
    Link,
} from "./OpenPositionListSection.styled";
import OpenPositionsSectionProps from "./OpenPositionListSectionProps";

const OpenPositionsSection = ({
    identifier,
    theme = "blue",
    displayOption = "Left",
    heading,
    link,
    items,
    anchorName,
}: OpenPositionsSectionProps): ReactElement => {
    const isInEditMode = useIsInEditMode();
    const headerState = useHeader();

    link =
        link ||
        (isInEditMode ? { linkText: "", url: "", title: "" } : undefined);

    return (
        <Section theme={theme} id={anchorName} alignItems="center">
            <ThemeProvider
                theme={{
                    displayOption: displayOption,
                }}
            >
                <Container {...addEditAttributes("OpenPositionsBlock")}>
                    <Heading
                        {...addEditAttributes("Heading")}
                        $headerVisible={headerState.visible}
                    >
                        {heading}
                    </Heading>
                    <Content>
                        <OpenPositionList
                            key={identifier || `OpenPositionsSectionContent`}
                            items={items}
                        />
                        {(isInEditMode || link?.url) && (
                            <Link
                                title={link?.title}
                                to={link?.url}
                                hoverSpan={true}
                                target="_blank"
                            >
                                <span>{link?.linkText}</span>
                                <Icon
                                    icon={"longArrowRight28"}
                                    aria-hidden="true"
                                />
                            </Link>
                        )}
                    </Content>
                </Container>
            </ThemeProvider>
        </Section>
    );
};

export default React.memo(OpenPositionsSection);
